/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { ISchemaConstFloatModel, TGenericModelNode } from "@adapptio/lib-blueprint";
import { IInspectorControls, TInspectorControlComponent } from "../InspectorTypes";
import { useBlueprintModel } from "../../../hooks/useBlueprintModel";
import { InvalidModelNode } from "../InvalidModelNode";
import { FieldNumber } from "../../Fields/FieldNumber";

export const ControlConstFloat_Primary: TInspectorControlComponent<ISchemaConstFloatModel> = ({
	model: _model,
	id
}) => {
	const { model, validationErrors } = useBlueprintModel(_model, "constFloat");

	const handleChange = useCallback(
		(value: number) => {
			if (!model) {
				return;
			}

			model.schema.setValue(model, value, true);
		},
		[ model ]
	);

	if (!model) {
		return <InvalidModelNode model={_model} />;
	}

	return (
		<FieldNumber
			id={id}
			value={model.value}
			onChange={handleChange}
			validationErrors={validationErrors}
			grow={true}
			min={model.schema.opts.constraints?.min}
			max={model.schema.opts.constraints?.max}
		/>
	);
};

export const ControlConstFloat = (model: TGenericModelNode): IInspectorControls => ({
	primary: {
		component: ControlConstFloat_Primary,
		model: model
	}
});
